import { API_URL } from "./Config";
import { PageResult } from "./Pagination";

export interface ILicenceSearchRow {
  licence_profile_id: string;
  name: string;
  profile_number: string;
  active_licence_id: string;
  active_licence_type: string;
  active_licence_regno: string;
  county: string;
  town: string;
  organisation_name: string;
  active_applicatio_number: string;
  active_application_id: string;
  active_application_licence_id: string;
  active_application_licence_regno: string;
  url: string;
}

export interface ILicenceSearchList extends PageResult {
  list: ILicenceSearchRow[];
}

export interface IAuthorisationType {
  name: string;
  value: string;
}

export interface IAuthorisationTypesList {
  list: IAuthorisationType[];
}

export interface IBasicSearchFiltersProps {
  authorisationTypes: string[];
}

export async function GetAuthorisationTypesAsync(): Promise<IAuthorisationTypesList> {
  let url = `${API_URL}/Licence/searchtypesfilter`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/authorisation-types-filter`;
  }

  var response = await fetch(url);
  var body = <IAuthorisationTypesList>await response.json();
  body.list = body.list.map((item) => {
    return <IAuthorisationType>{
      name: item.name,
      value: item.value,
    };
  });
  return body;
}

export const GetLicenceProfileSearchFetchUrl = (
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  let params = `page=${pageNo}&per_page=${recordsPerPage}&order_by=profilenumber`;

  let filterParams = "";
  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      if (filterId === "authorisation_type") {
        filterId = "licence_type_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "active_application") {
        filterId = "active_application_filter";
        filterParams += `&${filterId}=${f.value}`;
      } else {
        filterParams += `&${filterId}=${f.value}`;
      }
    }
  }

  if (searchText && searchText.length > 0) {
    filterParams += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/LicenceProfile/licenceprofilesearchlist?${params}${filterParams}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/profile-basic-search`;
  }

  return url;
};
